module.exports = __webpack_public_path__ + "img/call.e7d58863.svg";